
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/subscriptions/subscription/[id]",
      function () {
        return require("private-next-pages/admin/subscriptions/subscription/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/subscriptions/subscription/[id]"])
      });
    }
  